import React, { Component } from 'react';

class SimultaneousAccessByPlataform extends Component {
    constructor(props) {
        super(props);
        let data = {};
        let me = this;

        if (this.props.tipoPlataforma != undefined) {
            this.props.tipoPlataforma.forEach(function (p) {
                p.CodigoState = p.Descripcion.replace(/[^a-zA-Z]+/g, '').toUpperCase();
                let exist = me.props.accesosPorPlataforma.find(function (pla) {
                    return pla.plataformaId == p.Id
                })

                data[p.CodigoState] = (exist) ? exist.value : "0";
            });
        }

        this.state = {
            data,
            seteoRulesValidacion: false
        }
    }

    onHandleInputFocus(event) {
        event.target.select();
    }

    onHandleInputChange(event) {
        let plataformas = this.state.data;
        let plataformaId = event.target.dataset.plataformaid
        plataformas[event.target.name] = event.target.value;

        this.setState({ data: plataformas });
        this.props.setAccesosSimultaneosPorPlataforma(plataformaId, event.target.value);
    }

    onHandlePlataformaKeyPress(event) {
        let regExp = /[0-9]/g;
        let result = regExp.test(event.key);

        if (!result) {
            event.preventDefault();
        }
    }

    componentWillReceiveProps(nextProps) {
        let data = {};

        if (nextProps.tipoPlataforma != undefined) {
            nextProps.tipoPlataforma.forEach(function (p) {
                p.CodigoState = p.Descripcion.replace(/[^a-zA-Z]+/g, '').toUpperCase();
                let exist = nextProps.accesosPorPlataforma.find(function (pla) {
                    return pla.plataformaId == p.Id
                })

                data[p.CodigoState] = (exist) ? exist.value : "0";
            });
        }

        this.setState({
            data
        });

        if (this.state.seteoRulesValidacion == false) {
            if (nextProps.tipoPlataforma != undefined) {
                let messages = {};
                let options = {};
                let rules = {};

                let form = $("#simultaneous-access-by-plataform");

                $.validator.addMethod("valueNotEquals", function (value, element, arg) {
                    return arg != value;
                });

                Object.keys(data).forEach(function (value) {
                    rules[value] = { required: true, valueNotEquals: "0" };
                    messages[value] = { required: "Ingrese un valor", valueNotEquals: "Por favor, ingrese un valor" };
                });

                options = { rules: rules, messages: messages }

                form.validate(options);

                this.setState({
                    seteoRulesValidacion: true
                });
            }
        }
    }

    onHandleChange(e) {
        let _value = parseInt(e.target.value);
        this.props.updateInformacionUsuario('PlataformaId', _value);
    }

    onPasteText(e) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    }

    render() {
        if (this.props.tipoPlataforma == undefined)
            return null;

        //if (this.props.usuarioTipoPlataforma == undefined && this.props.tipoPlataforma.length > 0)          
        //this.props.updateInformacionUsuario('PlataformaId', this.props.tipoPlataforma[0].Id);

        let oTipoPlataforma = this.props.tipoPlataforma.map(function (s, index) {
            return <option key={"plataforma-" + index} value={s.Id}>{s.Descripcion}</option>
        });

        let context = this;
        let plataformas = this.props.tipoPlataforma.filter(x => x.ValidCanLog);
        plataformas = plataformas.map(function (plat, index) {
            return (
                <div className="row bottom-separator-xxs" key={"plataforma-div" + index}>
                    <label className="col-xs-2" htmlFor={plat.CodigoState} >
                        {plat.Descripcion + ":"} </label>
                    <div className="col-xs-1">
                        <input maxLength="1" className="form-control default-input" required
                            id={plat.CodigoState} name={plat.CodigoState}
                            data-plataformaid={plat.Id} value={context.state.data[plat.CodigoState]}
                            onChange={(event) => context.onHandleInputChange(event)}
                            onKeyPress={(event) => context.onHandlePlataformaKeyPress(event)}
                            onFocus={(event) => context.onHandleInputFocus(event)}
                            onPaste={(event) => context.onPasteText(event)} />
                    </div>
                    <div className="col-xs-9">
                        <label htmlFor={plat.CodigoState} generated="true" className="error"></label>
                    </div>
                </div>);
        });

        return (
            <form id="simultaneous-access-by-plataform">
                <div className="row bottom-separator-xxs">
                    <div className="col-xs-12">
                        <label className="label-primary">Accesos máximos simultáneos por tipo de plataforma</label>
                    </div>
                </div>
                <div className="simultaneous-access">
                    {plataformas}
                </div>
                <br></br>
                <div className="row bottom-separator-xxs">
                    <div className="col-xs-12">
                        <label className="label-primary">Plataforma predeterminada</label>
                    </div>
                </div>
                <div className="row simultaneous-access">
                    <div className="col-xs-3">
                        <select name="tipoPlataformaId" id="TipoPlataformaId" className="form-control default-input"
                            value={this.props.usuarioTipoPlataforma} data-userinfo="TipoPlataformaId"
                            onChange={(e) => this.onHandleChange(e)}>
                            {oTipoPlataforma}
                        </select>
                    </div>
                </div>
            </form>
        );
    }
}

export default SimultaneousAccessByPlataform;